<div class="modelContainer">
    <div class="">
      <button (click)="onCancelClick(false)" type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
        Close
      </button>
    </div>
    <div class="modelTitle heading2 alignCenter">
      <span *ngIf="data.displayType=='add'">Create Notification Subscription</span>
      <span *ngIf="data.displayType=='view'">View Notification Subscription</span>
      <span *ngIf="data.displayType=='edit'">Edit Notification Subscription</span>
    </div>
    <div class="modelBody regularText">
      <form [formGroup]="notificationDetailForm">
        <div *ngIf="isLoading" class="svg-loader"></div>
        
        <div class="form-group row">
          <div class="col-1"></div>
          <label for="tenantId" class="col-4 mandatory-field no-padding"><strong>Tenant Name</strong></label>
          <div class="col-6 zero-padding">
            <select id="tenantId" class="form-control select-btn" required formControlName="tenantId">
                <option value="" disabled selected>Select Tenant Name</option>
                <option *ngFor="let element of tenantList" [ngValue]="element.tenantId">{{element.tenantName}}</option>
              </select>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="form-group row mt-3">
            <div class="col-1"></div>
            <label for="notificationCategoryId" class="col-4 mandatory-field no-padding"><strong>Notification Category</strong></label>
            <div class="col-6 zero-padding">
              <select id="notificationCategoryId" (change)="disableSave()" class="form-control select-btn" required formControlName="notificationCategoryId">
                <option value="" disabled selected>Select Category</option>
                <option *ngFor="let element of categoryList" [ngValue]="element.notificationCategoryId">{{element.categoryName}}</option>
              </select>
            </div>
            <div class="col-1"></div>
        </div>
        
        <div class="form-group row mt-3">
          <div class="col-1"></div>
          <label for="channelName" class="col-4 mandatory-field no-padding"><strong>Channel Name</strong></label>
          <div class="col-6 zero-padding">
            <input type="text" formControlName="channelName" class="form-control" id="channelName"/>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="form-group row mt-3">
            <div class="col-1"></div>
            <label for="webHookUrl" class="col-4 mandatory-field no-padding"><strong>Webhook URL</strong></label>
            <div class="col-6 zero-padding">
              <input type="text" formControlName="webHookUrl" class="form-control" id="webHookUrl"/>
              <div class="invalid-entry" *ngIf="notificationDetailForm.get('webHookUrl').errors?.pattern">
                It should be a https URL.
              </div>  
            </div>
            <div class="col-1"></div>
        </div>
            
        <div class="form-group row mt-3">
            <div class="col-1"></div>
            <label for="notificationType" class="col-4 mandatory-field no-padding"><strong>Notification Type</strong></label>
            <div class="col-6 zero-padding">
                <mat-checkbox class="mr-2" formControlName="successNotification">
					          Success</mat-checkbox>                
                <mat-checkbox class="mr-2" formControlName="failureNotification">
                    Failed</mat-checkbox>
            </div>
            <div class="col-1"></div>
        </div>   
        
        <div class="form-group row mt-3" *ngIf="notificationDetailForm.controls.notificationCategoryId.value === 2">
          <div class="col-1"></div>
          <label for="reportScheduleId" class="col-4 mandatory-field no-padding"><strong>Schedule</strong></label>
          <div class="col-6 zero-padding">
            <select id="reportScheduleId" class="form-control select-btn" formControlName="reportScheduleId">
              <option value="" selected>Select Schedule</option>
              <option *ngFor="let element of schedulerList" [ngValue]="element.reportScheduleId">{{element.reportScheduleName}}</option>
             
            </select>
          </div>
          <div class="col-1"></div>
      </div>
       
        <div class="d-flex alignCenter">
          <button id="createBtn" type="submit" *ngIf="data.displayType != 'view'" class="saveBtn2 mt-2" (click)="saveSubscription()"
                  [disabled]="disableSave()">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
  